<p>reservation-summary-accomodation-service-dialog works!</p>
